export default __webpack_public_path__ + "static/media/fullscreen-exit.06ab8b4e.svg";